// extracted by mini-css-extract-plugin
export default {"card":"ShrunkWorkCard_card__qvr1K","link":"ShrunkWorkCard_link__zclXb","zoom":"ShrunkWorkCard_zoom__ZzHRC","img":"ShrunkWorkCard_img__k1o5e","h1":"ShrunkWorkCard_h1__bp0js"};